import { createContext, useContext, useEffect, useState, ReactNode } from "react";
import "react-toastify/dist/ReactToastify.css";
import useFetch from "../hooks/use-fetch";
import { AuthContext } from "./AuthProvider";
import { ReportData } from "./ReportContext";

export type NotificationType = {
  id: number;
  kind: "success" | "error";
  created_at: string;
  content: string;
  read: boolean;
  report: ReportData
};

type NotificationContextType = {
  notifications: NotificationType[];
  fetchNotifications: () => Promise<void>;
  readNotifications: (notificationIds: number[]) => Promise<void>
};

const NotificationContext = createContext<NotificationContextType | undefined>(undefined);

export const NotificationProvider = ({ children }: { children: ReactNode }) => {
  const { get, post } = useFetch();
  const { isAuth } = useContext(AuthContext);
  const [notifications, setNotifications] = useState<NotificationType[]>([]);

  
  useEffect(() => {
    if (!isAuth) return

    fetchNotifications();
    const interval = setInterval(fetchNotifications, 10000);
    return () => clearInterval(interval);
  }, [isAuth]);


  const fetchNotifications = async () => {
    try {
      const data = await get("notifications/?n=50");
      if (data && Array.isArray(data.notifications)) {
        setNotifications(data.notifications);
      }
    } catch (error) {
      console.error("Error fetching notifications:", error);
    }
  };

  const readNotifications = async (notificationIds: number[]) => {
    try {
      const data = await post(`notifications/`, notificationIds)
    } catch (err){
      console.log('Error reading notifications.')
    }
    fetchNotifications()
  }

  return (
    <NotificationContext.Provider
      value={{ notifications, fetchNotifications, readNotifications }}
    >
      {children}
    </NotificationContext.Provider>
  );
};

export const useNotification = () => {
  const ctx = useContext(NotificationContext);
  if (!ctx) {
    throw new Error("useNotification must be used within a NotificationProvider");
  }
  return ctx;
};
